/**
 * Defines the standard Bootstrap variants for toasts, buttons etc.
 */

export enum BootstrapVariant {
  //TODO Use this instead of plain strings wherever a bootstrap variant is specified.
  warning = 'warning',
  danger = 'danger',
  info = 'info',
  primary = 'primary',
  secondary = 'secondary',
  default = 'default',
  success = 'success',
  tooltipGreen = 'tooltip-green',
}
